module.exports = __webpack_public_path__ + "files/e4767b1b020cbd45451d795ec8f01abe.png";